import { Link, Button } from '@/shared/components';
import { MinusCircleIcon, GiftIcon, LockUnlockedIcon } from '@/shared/icons/small';
import { DashboardModal } from './dashboards/Modal';
import useLocalStorage from '../hooks/useLocalStorage';

export const StrategiesIntroductionModal = (): JSX.Element => {
  const [displayModal, setDisplayModal] = useLocalStorage(
    'displayStrategiesIntroductionModal',
    (value) => (typeof value === 'boolean' ? value : true),
  );
  return (
    <DashboardModal
      open={displayModal}
      onClose={() => setDisplayModal(false)}
      afterLeave={() => setDisplayModal(false)}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-y-2 font-aeonikRegular text-white backdrop-blur-[5px]">
        <div className="w-[653px] rounded-[6px] border border-cf-gray-3-5 bg-cf-gray-2 p-8 shadow-grayPop2">
          <div className="font-aeonikMedium text-24 text-cf-white">
            Automated Stablecoin Strategies
          </div>
          <div className="my-6 flex flex-col gap-y-6 rounded-[6px] border border-cf-gray-4 bg-cf-gray-3 p-8 shadow-grayPop1">
            <div className="flex w-full items-center gap-6">
              <div className="flex h-[120px] w-[459px] items-center justify-center overflow-hidden rounded-[6px] border border-cf-gray-4 bg-cf-gray-3-5 shadow-[0_0_0_2px_rgba(10,10,10,0.15),inset_3px_3px_18px_rgba(0,0,0,0.04)]">
                <img
                  src="/buildYourEdge.svg"
                  alt="Build Edge"
                  className="block h-full w-full object-cover"
                />
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-x-1">
                  <span className="text-cf-light-2">
                    <MinusCircleIcon />
                  </span>
                  <span className="font-aeonikMedium text-14 text-cf-white">Build Your Edge</span>
                </div>
                <span className="font-aeonikMedium text-14 text-cf-light-2">
                  Define your own strategy — set exact spreads and let others follow your lead.
                </span>
                <Link
                  href="https://blog.chainflip.io/automated-stablecoin-strategies/"
                  target="_blank"
                  className="font-aeonikMedium text-14 !text-cf-green-1"
                >
                  Read the blogpost
                </Link>
              </div>
            </div>
            <div className="flex w-full items-center gap-6">
              <div className="flex h-[120px] w-[418px] items-center justify-center overflow-hidden rounded-[6px] border border-cf-gray-4 bg-cf-gray-3-5 shadow-[0_0_0_2px_rgba(10,10,10,0.15),inset_3px_3px_18px_rgba(0,0,0,0.04)]">
                <img
                  src="/earnPassively.svg"
                  alt="earnPassively"
                  className="block h-full w-full object-cover"
                />
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-x-1">
                  <span className="text-cf-light-2">
                    <GiftIcon />
                  </span>
                  <span className="font-aeonikMedium text-14 text-cf-white">Earn Passively</span>
                </div>
                <span className="font-aeonikMedium text-14 text-cf-light-2">
                  Deposit your stables and earn yield effortlessly - no upkeep, no stress.
                </span>
              </div>
            </div>
            <div className="flex w-full items-center gap-6">
              <div className="flex h-[120px] w-[446px] items-center justify-center overflow-hidden rounded-[6px] border border-cf-gray-4 bg-cf-gray-3-5 shadow-[0_0_0_2px_rgba(10,10,10,0.15),inset_3px_3px_18px_rgba(0,0,0,0.04)]">
                <img
                  src="/exitAnytime.svg"
                  alt="exit"
                  className="block h-full w-full object-cover"
                />
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-x-1">
                  <span className="text-cf-light-2">
                    <LockUnlockedIcon />
                  </span>
                  <span className="font-aeonikMedium text-14 text-cf-white">Exit Anytime</span>
                </div>
                <span className="font-aeonikMedium text-14 text-cf-light-2">
                  Close out whenever you like. Your funds are instantly available - no lockups.
                </span>
              </div>
            </div>
          </div>
          <Button fullWidth type="primary-standard" onClick={() => setDisplayModal(false)}>
            Start now
          </Button>
        </div>
      </div>
    </DashboardModal>
  );
};
